import React from 'react';

const BlurSpan = ({ children, isBlur }) => {
  return (
    <span style={{ filter: isBlur ? 'blur(4px)' : 'none' }}>
      {children}
    </span>
  );
};

export default BlurSpan;